import type { FunctionComponent } from 'react';
import { lazy, Suspense } from 'react';

import type { DialogProps } from '../components';
import { useToken } from '../hooks';

const Dialog = lazy<FunctionComponent<DialogProps>>(async () => ({
  default: (await import('../components')).Dialog,
}));

export const ProductInfoDialog = () => {
  const token = useToken();

  return <Suspense fallback={null}>{token ? <Dialog token={token} /> : null}</Suspense>;
};
